import React, {  useEffect, useRef } from 'react';
import './WizardProgress.scss'
import { StepType } from 'components/Wizard/Wizard';
import Button from 'react-bootstrap/Button';

export default function WizardProgress({ steps, currentStep, completedSteps, changeStep })
{

    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current)
            inputRef.current.focus();
    }, [currentStep]);

    if (!steps)
        return (<></>);

    return (
        <>
            <div className="wizardprogress-row" data-current-step={currentStep}>
                {steps.map((step, index) => {
                    var iCompleted = (completedSteps.indexOf(index) !== -1);
                    var iActive = (index === currentStep || iCompleted);

                if (step.type === StepType.PartialStep)
                    return null;

                return (                      
                    <div key={index} className="wizardprogress-cell">
                        {index === 0 ? <></> : <div className={"wizardprogress-stepline" + ((iActive || (index !== 0 && steps[index - 1].type === StepType.PartialStep && (index - 1) === currentStep))  ? "-active" : "") } style={{ right: "54%" }} />}
                        <div className={"wizardprogress-step" + (iActive ? "-active" : "")}>
                            <span className={(iCompleted ? "fas fa-check" : "fas")}>&nbsp;</span>
                        </div>
                        {index === (steps.length - 1) ? <></> : <div className={"wizardprogress-stepline" + (iActive ? "-active" : "")} style={{ left: "54%" }} /> }                            
                    </div>
                ) 
            })}
            </div>
            <div className="wizardprogress-row">
                {steps.map((step, index) => {
                    var iCompleted = (completedSteps.indexOf(index) !== -1);
                    // Disable progress button of later steps even if completed.  
                    // Step advances limited to Continue button.
                    var iActive = (index <= currentStep);  
                                             /*   Current Step   */    /*                     Next Step is Partial so Continue to Highligh This Step                       */
                    var highlightStep = (index === currentStep || (index < (steps.length - 1) && steps[index + 1].type === StepType.PartialStep && (index + 1) === currentStep));

                    if (step.type === StepType.PartialStep)
                        return null;

                    return (
                        <div key={index} className={((highlightStep) ? "wizardprogress-current " : " ") + ((step.hasErrors) ? "wizardprogress-error" : (iActive) ? "wizardprogress-active" : "")} >
                            <Button variant="link" type="button" className="wizardprogress-steplink" ref={((index === 0 && index === currentStep && iCompleted) || (currentStep > 0 && highlightStep)) ? inputRef : null} tabIndex={(iActive) ? 0 : -1} onClick={e => iActive ? changeStep(e, index) : e.preventDefault()} >
                                <span className='visually-hidden'>{(index === currentStep) ? "Current:" : (iCompleted) ? "Completed:" : ""}</span>
                                {step.name}
                                <span className='visually-hidden'>{(steps[index].hasErrors) ? "Has Errors" : ""}</span></Button>
                        </div>)
                })}
            </div>
        </>
    );
}